module.exports = __webpack_public_path__ + "media/images/country_flags/ky-36f7e8f4e3dbaf688d73012792bd7e68.png";